import React, { useEffect } from 'react';
import AOS from 'aos';

import 'aos/dist/aos.css';

type ScrollAnimationProps = {
	animateIn?: string;
	animateOut?: string;
	animateOnce?: boolean;
	offset?: number;
	delay?: number;
	initiallyVisible?: boolean;
	className?: string;
	children: React.ReactNode;
};

// Mapping from react-animate-on-scroll animations to AOS animations
const mapAnimationToAOS = (animation: string): string => {
	const animationMap: Record<string, string> = {
		fadeIn: 'fade',
		fadeInUp: 'fade-up',
		fadeInDown: 'fade-down',
		fadeInLeft: 'fade-left',
		fadeInRight: 'fade-right',
		fadeOut: 'fade',
		fadeOutUp: 'fade-up',
		fadeOutDown: 'fade-down',
		zoomIn: 'zoom-in',
		zoomOut: 'zoom-out',
		pulse: 'flip-up' // AOS doesn't have pulse, using flip-up as alternative
	};

	return animationMap[animation] || 'fade';
};

// Inspired by the react-animate-on-scroll library:
// https://github.com/dbramwell/react-animate-on-scroll
const ScrollAnimation = ({
	animateIn = 'fade',
	animateOut,
	animateOnce = false,
	offset = 150,
	delay = 0,
	initiallyVisible = false,
	className,
	children
}: ScrollAnimationProps) => {
	useEffect(() => {
		AOS.init({
			duration: 800,
			offset: offset
		});
	}, [offset]);

	const aosAnimation = mapAnimationToAOS(animateIn);

	// If initially visible, don't apply animation
	if (initiallyVisible) {
		return <div className={className}>{children}</div>;
	}

	return (
		<div data-aos={aosAnimation} data-aos-delay={delay} data-aos-once={animateOnce} className={className}>
			{children}
		</div>
	);
};

export default ScrollAnimation;
